// extracted by mini-css-extract-plugin
export default {"title":"ToolBoxGroup_title__S8+60","content":"ToolBoxGroup_content__pLp02","row":"ToolBoxGroup_row__SQgWz","coloredRow":"ToolBoxGroup_coloredRow__Gaott ToolBoxGroup_row__SQgWz"};